const WORD_SEPARATOR_REGEX = /[\s/\-_,.;]+/;

const removeVietnameseDiacritics = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');

/**
 * Generates an acronym from a phrase by taking the first letter of each word.
 * Vietnamese diacritics are removed and the result is uppercased.
 */
export const generateAcronym = (text: string): string => {
  if (!text?.trim()) {
    return '';
  }

  return text
    .trim()
    .split(WORD_SEPARATOR_REGEX)
    .filter((word) => word.length > 0)
    .map((word) => {
      const firstChar = word.charAt(0);

      return removeVietnameseDiacritics(firstChar);
    })
    .join('')
    .toUpperCase();
};
